@let t = text();
@let now = nowMarker();
@let gateMode = gateInfoMode();

<!-- Eén scrollcontainer zonder zichtbare scrollbalk: de weekstrip en de
     maandkalender van de host tonen waar je zit. Tabindex zodat pijltjes/
     Page Up/Down native scrollen. -->
<div #scroller class="day-flow" tabindex="0" [attr.aria-label]="t.flowAria">
  @for (day of dayVms(); track day.key) {
    <section class="day-flow__day"
             [class.day-flow__day--today]="day.isToday"
             [class.day-flow__day--pending]="day.placeholder"
             [attr.data-day-key]="day.key"
             [attr.aria-label]="day.ariaLabel">
      <!-- Agenda-achtige datumrail; sticky binnen de eigen dag. Onderaan de
           knop voor een moment op de hele dag (de plusjes per wissel hangen
           in dezelfde kolom, aan hun eigen blok). De I Tjing-raadpleging per dag
           zit sinds 2026-10-24 in het I Tjing-dagpaneel (icoon rechtsboven). -->
      <div class="day-flow__rail">
        <span class="day-flow__rail-weekday" aria-hidden="true">{{ day.weekday }}</span>
        <span class="day-flow__rail-number" aria-hidden="true">{{ day.dayNumber }}</span>
        <span class="day-flow__rail-month" aria-hidden="true">{{ day.monthLabel }}</span>
        @if (day.isToday) {
          <span class="day-flow__rail-today" [class.day-flow__rail-today--long]="t.todayLong" aria-hidden="true">{{ t.today }}</span>
        }
        <button type="button" class="day-flow__add day-flow__add--day"
                [attr.aria-label]="t.addMomentDay" [title]="t.addMomentDay"
                (click)="requestDayMoment(day)" data-test-id="day-flow-add-day">
          <i class="fas fa-calendar-plus" aria-hidden="true"></i>
        </button>
      </div>

      <div class="day-flow__body">
        <header class="day-flow__day-header">
          <!-- Stand van alle planeten bij de start van de dag (00:00 lokaal). -->
          <div class="day-flow__positions" [attr.aria-label]="t.startPositions" [title]="t.startPositions">
            @for (position of day.positions; track position.planetKey) {
              <span class="day-flow__position" [style.--planet-color]="position.color" [title]="position.tooltip">
                <span class="day-flow__glyph" aria-hidden="true">{{ position.glyph }}</span>
                <span class="day-flow__position-value">{{ position.label }}</span>
                @if (position.retrograde) {
                  <span class="day-flow__rx" [title]="t.retrograde">℞</span>
                }
              </span>
            }
          </div>
          <!-- Classic I Ching: hexagram van deze dag (zon, maan, dagteller) in het paneel; alleen een icoon. -->
          @if (ichingIconsVisible() && ichingDays().has(day.key)) {
            <button type="button" class="day-flow__iching" data-test-id="day-flow-iching-day"
                    [attr.aria-label]="t.ichingDay" [title]="t.ichingDay"
                    (click)="openIChingDay(day, $event)">
              <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
            </button>
          }
        </header>

        @if (day.pending) {
          <!-- De data van (een deel van) de planeten is voor die dag nog niet binnen. -->
          <p class="day-flow__empty day-flow__empty--loading">
            <i class="fas fa-circle-notch fa-spin day-flow__spinner" aria-hidden="true"></i>
            {{ t.loadingDay }}
          </p>
        } @else if (day.entries.length === 0) {
          <p class="day-flow__empty">{{ t.noShifts }}</p>
        }

        @for (entry of day.entries; track entry.id; let index = $index) {
          @if (now?.dayKey === day.key && now?.index === index) {
            <ng-container *ngTemplateOutlet="nowLine" />
          }

          @if (entry.type === 'station') {
            <div class="day-flow__station" data-entry-type="station" [style.--planet-color]="entry.color">
              <span class="day-flow__time">{{ entry.timeText }}</span>
              <span class="day-flow__glyph" aria-hidden="true">{{ entry.glyph }}</span>
              <span class="day-flow__station-text">{{ entry.planetName }} {{ entry.text }}</span>
            </div>
          } @else if (entry.type === 'season') {
            <!-- Zonnewende of equinox: de zon op een cardinale lengte, lijn 2 van een Vessel of Love-poort. -->
            <div class="day-flow__season" data-entry-type="season">
              <span class="day-flow__time">{{ entry.timeText }}</span>
              <i class="day-flow__season-icon fa-solid fa-{{ entry.icon }}" aria-hidden="true"></i>
              <span class="day-flow__season-text">{{ entry.text }}</span>
              <span class="day-flow__season-detail">{{ entry.detail }}</span>
            </div>
          } @else {
            <article class="day-flow__shift"
                     data-entry-type="shift"
                     [class.day-flow__shift--gate]="entry.kind === 'gate'"
                     [style.--planet-color]="entry.color"
                     [attr.data-test-id]="'day-flow-shift-' + entry.id">
              <div class="day-flow__shift-head">
                <button type="button" class="day-flow__shift-main" [title]="t.openDetails"
                        (click)="openShiftDetails(entry, $event)">
                  <span class="day-flow__time">{{ entry.timeText }}</span>
                  <span class="day-flow__planet">
                    <span class="day-flow__glyph" aria-hidden="true">{{ entry.glyph }}</span>
                    <span class="day-flow__planet-name">{{ entry.planetName }}</span>
                    @if (entry.retrograde) {
                      <span class="day-flow__rx" [title]="t.retrograde">℞</span>
                    }
                  </span>
                  <span class="day-flow__transition">
                    @if (entry.previousText) {
                      <span class="day-flow__prev" [title]="t.previous">{{ entry.previousText }}</span>
                      <span class="day-flow__arrow" aria-hidden="true">→</span>
                    }
                    <span class="day-flow__current">{{ entry.currentText }}</span>
                    @if (entry.nextText) {
                      <span class="day-flow__arrow day-flow__arrow--soft" aria-hidden="true">→</span>
                      <span class="day-flow__next" [title]="t.next">{{ entry.nextText }}</span>
                    }
                  </span>
                  <span class="day-flow__duration" [title]="entry.untilTooltip">
                    <i class="fa-regular fa-hourglass-half" aria-hidden="true"></i>
                    {{ entry.durationText }}
                  </span>
                </button>
                @if (entry.kind === 'gate' && gateShiftBadge()) {
                  <span class="day-flow__gate-badge">{{ t.gateShift }}</span>
                }
                @if (entry.quarterStartText) {
                  <span class="day-flow__gate-badge day-flow__gate-badge--quarter">{{ entry.quarterStartText }}</span>
                }
                @if (entry.raveNewYear; as raveNewYear) {
                  <!-- De zon gaat poort 41 in: start van het Rave-jaar; klik = de transit-chart van dat moment. -->
                  <button type="button" class="day-flow__gate-badge day-flow__gate-badge--rave-new-year"
                          [title]="raveNewYear.tooltip"
                          (click)="requestRaveNewYear(entry, $event)" data-test-id="day-flow-rave-new-year">
                    <i class="fas fa-{{ raveNewYearIcon }}" aria-hidden="true"></i>
                    {{ t.raveNewYear }}
                  </button>
                }
                @if (gateMode === 'badge') {
                  <!-- Poortbadge: poortnummer + de twee keynotes van de poort; doorklik naar de gate-info. -->
                  <button type="button" class="day-flow__gate-link day-flow__gate-link--keynotes"
                          [title]="entry.gateVm.openLabel"
                          (click)="openGateInfo(entry, $event)"
                          data-test-id="day-flow-gate-badge">
                    <span class="day-flow__gate-link-number-col">
                      <span class="day-flow__gate-link-caption">{{ t.gateCaption }}</span>
                      <span class="day-flow__gate-link-number">{{ entry.gateVm.gate }}</span>
                    </span>
                    <span class="day-flow__gate-link-keynotes">
                      <span class="day-flow__gate-link-keynote1">{{ entry.gateVm.keynote1 }}</span>
                      @if (entry.gateVm.keynote2) {
                        <span class="day-flow__gate-link-keynote2">{{ entry.gateVm.keynote2 }}</span>
                      }
                    </span>
                  </button>
                } @else {
                  <button type="button" class="day-flow__gate-link" (click)="openGateInfo(entry, $event)">
                    {{ entry.gateLinkText }}
                  </button>
                }
                @if (!entry.lineVm) {
                  <!-- Zuiver poort-segment (geen lijnsectie): het plusje hangt ter hoogte van de kop. -->
                  <button type="button" class="day-flow__add day-flow__add--shift day-flow__add--at-head"
                          [attr.aria-label]="t.addMoment" [title]="t.addMoment"
                          (click)="requestShiftMoment(entry)" data-test-id="day-flow-add-shift">
                    <i class="fas fa-plus" aria-hidden="true"></i>
                  </button>
                }
              </div>

              @if (gateMode === 'row') {
                <!-- Poortrij: de poort zelf (nummer, hexagram, keynotes en korte I Tjing-
                     beschrijving) boven de lijnsectie, in dezelfde kolomindeling. -->
                <button type="button" class="day-flow__gate-row"
                        [title]="entry.gateVm.openLabel"
                        (click)="openGateInfo(entry, $event)"
                        data-test-id="day-flow-gate-row">
                  <span class="day-flow__gate-row-number-col">
                    <span class="day-flow__gate-row-number">{{ entry.gateVm.gate }}</span>
                    @if (entry.gateVm.hexagram) {
                      <span class="day-flow__gate-row-hexagram" aria-hidden="true">{{ entry.gateVm.hexagram }}</span>
                    }
                  </span>
                  <span class="day-flow__gate-row-text">
                    <span class="day-flow__gate-row-keynotes">
                      <span class="day-flow__gate-row-keynote1">{{ entry.gateVm.keynote1 }}</span>
                      @if (entry.gateVm.keynote2) {
                        <span class="day-flow__gate-row-keynote2">{{ entry.gateVm.keynote2 }}</span>
                      }
                    </span>
                    @if (entry.gateVm.description) {
                      <span class="day-flow__gate-row-description">{{ entry.gateVm.description }}</span>
                    }
                  </span>
                </button>
              }

              @if (entry.lineVm; as lineVm) {
                <!-- I Tjing-lijnsectie van de nieuwe stand (zoals de lijnkarakteristieken
                     in de gate-info), zonder de planetaire invloeden. Het plusje hangt
                     links in de railkolom, ter hoogte van het lijnnummer. -->
                <div class="day-flow__line">
                  <button type="button" class="day-flow__add day-flow__add--shift"
                          [attr.aria-label]="t.addMoment" [title]="t.addMoment"
                          (click)="requestShiftMoment(entry)" data-test-id="day-flow-add-shift">
                    <i class="fas fa-plus" aria-hidden="true"></i>
                  </button>
                  <hd-gate-line [viewModel]="lineVm" />
                </div>
              }
            </article>
          }
        }

        @if (now?.dayKey === day.key && now?.index === day.entries.length && day.entries.length > 0) {
          <ng-container *ngTemplateOutlet="nowLine" />
        }
      </div>
    </section>
  }
</div>

<!-- Amber nu-lijn: links het plusje voor een moment op dit moment (Steven
     2026-10-24), rechts de Just Now-chart van nu (enkel de transit; Steven
     2026-10-25), zolang de lijn het echte nu is. -->
<ng-template #nowLine>
  <div class="day-flow__now" role="separator">{{ t.now }} · {{ now?.time }}
    <button type="button" class="day-flow__add day-flow__add--now"
            [attr.aria-label]="t.addMomentNow" [title]="t.addMomentNow"
            (click)="requestNowMoment()" data-test-id="day-flow-add-now">
      <i class="fas fa-plus" aria-hidden="true"></i>
    </button>
    @if (justNowAvailable()) {
      <button type="button" class="day-flow__just-now"
              [title]="t.justNowTooltip"
              (click)="justNowRequested.emit()" data-test-id="day-flow-just-now">
        <i class="fas fa-{{ justNowIcon }}" aria-hidden="true"></i>
        {{ t.justNow }}
      </button>
    }
  </div>
</ng-template>
